import Currency from '@/core/components/presentationStandards/Currency.tsx'
import { CSSProperties } from 'react'

interface Props {
  field?: string | number | null
  align?: CSSProperties['textAlign']
}

const Tasa = ({ field, align }: Props) => {
  return <Currency field={field} align={align} />
}

export default Tasa
